import React, { useEffect, useRef, useState } from "react";
import { Moon, Sun, Palette } from "lucide-react";
import { usePanelTheme } from "../context/themeContext";

const options = [
  { key: "light", labels: { de: "Hell", sq: "Çelët" }, icon: Sun },
  { key: "blue", labels: { de: "Hellblau", sq: "Kaltër e çelët" }, icon: Palette },
  { key: "dark", labels: { de: "Dunkel", sq: "Errët" }, icon: Moon },
];

const copy = {
  de: {
    title: "Kontrast",
    subtitle: "Kontrast wählen",
  },
  sq: {
    title: "Ngjyrat",
    subtitle: "Zgjidh kontrastin",
  },
};

export default function ThemeSwitcher({ lang = "de" }) {
  const { theme, setTheme } = usePanelTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const activeLang = lang === "sq" ? "sq" : "de";
  const labels = copy[activeLang];
  const current = options.find((item) => item.key === theme) || options[0];
  const CurrentIcon = current.icon;

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-3 pr-4 shadow-sm transition hover:bg-slate-50"
      >
        <CurrentIcon className="h-4 w-4 shrink-0 text-slate-600" />

        <span className="text-[11px] font-black uppercase tracking-[0.18em] text-blue-600 sm:text-xs">
          {labels.title}
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-3 w-56 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
          <div className="border-b border-slate-100 px-4 py-3">
            <p className="text-xs font-black uppercase tracking-[0.2em] text-blue-600">{labels.title}</p>
            <p className="mt-1 text-xs text-slate-500">{labels.subtitle}</p>
          </div>

          <div className="p-2">
            {options.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => {
                    setTheme(item.key);
                    setOpen(false);
                  }}
                  className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left transition ${
                    item.key === theme
                      ? "bg-slate-900 text-white"
                      : "text-slate-700 hover:bg-slate-50"
                  }`}
                >
                  <Icon className={`h-4 w-4 ${item.key === theme ? "text-white" : "text-slate-500"}`} />
                  <span className="flex-1 text-sm font-semibold">{item.labels[activeLang]}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
